import type { AreaCatalog } from '../area';
import type { lists as en } from '../en/lists';

export const lists = {
  'lists.column.title': 'Titel',
  'lists.column.state': 'Status',
  'lists.column.health': 'Zustand',
  'lists.column.assignee': 'Zuständig',
  'lists.column.requester': 'Verantwortlich',
  'lists.column.flow': 'Ablauf',
  'lists.column.parent': 'Übergeordnete Aufgabe',
  'lists.column.due': 'Fällig',
  'lists.column.priority': 'Priorität',
  'lists.column.updated': 'Geändert',
  'lists.column.created': 'Erstellt',
  'lists.cell.priority.must': 'muss',
  'lists.cell.priority.should': 'soll',
  'lists.cell.priority.could': 'kann',

  'lists.table.columnMenu': 'Spalte {column}',
  'lists.table.sortAsc': 'Aufsteigend sortieren',
  'lists.table.sortDesc': 'Absteigend sortieren',
  'lists.table.moveLeft': 'Nach links',
  'lists.table.moveRight': 'Nach rechts',
  'lists.table.hideColumn': 'Spalte ausblenden',
  'lists.table.groupOptions': 'Abschnittsoptionen',
  'lists.table.groupOptionsFor': 'Abschnittsoptionen: {group}',
  'lists.table.more': '{count} weitere',
  'lists.table.moreLabel': '{count} weitere in {group} anzeigen',
  'lists.table.retry': 'Nicht gespeichert. Erneut versuchen',
  'lists.table.digest': '{done} von {total}',
  'lists.table.digestLabel': 'Ihre Liste: {done} von {total} erledigt',
  'lists.table.parents': 'Übergeordnete Aufgaben',

  'lists.surface.count': { one: '{count} Aufgabe', other: '{count} Aufgaben' },
  'lists.surface.empty': 'Noch nichts auf diesem Board.',
  'lists.columns.button': 'Spalten',
  'lists.columns.move': '„{column}“ verschieben',
  'lists.columns.show': '„{column}“ anzeigen',
  'lists.columns.hide': '„{column}“ ausblenden',

  'lists.checklist.addItem': 'Aufgabe hinzufügen',
  'lists.checklist.filterPlaceholder': 'Suchen oder filtern…',
  'lists.checklist.filterLabel': '{name} durchsuchen oder filtern',
  'lists.checklist.tidy': 'Aufräumen',
  'lists.checklist.tidyLabel': 'Aufräumen: die hier abgehakten Punkte zu den erledigten legen',
  'lists.checklist.pull': 'Ziehen zum Aufräumen',
  'lists.checklist.release': 'Loslassen zum Aufräumen',
  'lists.checklist.unreachable': 'Der Server war nicht erreichbar.',
  'lists.checklist.outside': {
    one: '{count} Unteraufgabe liegt außerhalb dieses Boards: Die Vererbung ist auf dem Weg nach unten unterbrochen, also könnten nicht alle hier sie sehen.',
    other:
      '{count} Unteraufgaben liegen außerhalb dieses Boards: Die Vererbung ist auf dem Weg nach unten unterbrochen, also könnten nicht alle hier sie sehen.',
  },
  'lists.completion.unreachable': 'Der Server war nicht erreichbar. Versuch es noch einmal.',

  'lists.aside.thisList': 'Dieses Board',
  'lists.aside.progress': '{done} von {total} erledigt',
  'lists.aside.progressClosed': '{done} von {total} erledigt · {closed} abgeschlossen',
  'lists.aside.progressOutside': '{done} von {total} erledigt · {outside} außerhalb',
  'lists.aside.progressClosedOutside':
    '{done} von {total} erledigt · {closed} abgeschlossen · {outside} außerhalb',
  'lists.aside.landsLabel': 'Neue Punkte landen',
  'lists.aside.landsUnder': 'unter {title}',
  'lists.aside.landsHere': 'auf diesem Board',
  'lists.aside.onIt': 'Zuständig',
  'lists.aside.lastChange': 'Letzte Änderung',
  'lists.aside.hint': 'Wähle einen Punkt, um ihn hier zu sehen.',
  'lists.aside.close': 'Schließen',
  'lists.aside.contributor': 'Zuständig',
  'lists.aside.requester': 'Verantwortlich',
  'lists.aside.flow': 'Ablauf',
  'lists.aside.group': { one: 'Gruppe', other: 'Gruppen' },
  'lists.aside.inherited': 'geerbt',
  'lists.aside.under': 'Unter',
  'lists.aside.health': 'Zustand',
  'lists.aside.changed': 'Geändert',
  'lists.aside.open': 'Aufgabe öffnen',
  'lists.due.late': '{count} T. überfällig',
  'lists.due.today': 'Heute fällig',
  'lists.due.tomorrow': 'Morgen fällig',
  'lists.due.weekday': 'Fällig {weekday}',
  'lists.due.day': 'Fällig {day}. {month}',
  'lists.due.dayYear': 'Fällig {day}. {month} {year}',
  'lists.due.week': 'Fällig KW{week}',
  'lists.due.weekYear': 'Fällig KW{week} {year}',
  'lists.due.month': 'Fällig {month}',
  'lists.due.monthYear': 'Fällig {month} {year}',
  'lists.due.quarter': 'Fällig Q{quarter}',
  'lists.due.quarterYear': 'Fällig Q{quarter} {year}',
  'lists.due.year': 'Fällig {year}',
  'lists.due.weekdayName.sun': 'So',
  'lists.due.weekdayName.mon': 'Mo',
  'lists.due.weekdayName.tue': 'Di',
  'lists.due.weekdayName.wed': 'Mi',
  'lists.due.weekdayName.thu': 'Do',
  'lists.due.weekdayName.fri': 'Fr',
  'lists.due.weekdayName.sat': 'Sa',
  'lists.due.monthName.jan': 'Jan.',
  'lists.due.monthName.feb': 'Feb.',
  'lists.due.monthName.mar': 'März',
  'lists.due.monthName.apr': 'Apr.',
  'lists.due.monthName.may': 'Mai',
  'lists.due.monthName.jun': 'Juni',
  'lists.due.monthName.jul': 'Juli',
  'lists.due.monthName.aug': 'Aug.',
  'lists.due.monthName.sep': 'Sept.',
  'lists.due.monthName.oct': 'Okt.',
  'lists.due.monthName.nov': 'Nov.',
  'lists.due.monthName.dec': 'Dez.',
  'lists.error.needsConfirmation':
    'Das braucht eine Bestätigung, nach der die Zeile nicht fragen kann.',
} as const satisfies AreaCatalog<typeof en>;
